import "@babel/polyfill";
import dotenv from "dotenv";
import React from "react";
import { render } from "react-dom";
import App from "containers/App/";
import "react-app-polyfill/ie11";
import store, { history } from "./store";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";

dotenv.config();

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.querySelector("#rps-ui-v2")
);
